<div class="max-w-[90vw] min-w-[60vw]">
    <form *ngIf="form" [formGroup]="form">
        
        <!-- Header -->
        <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary" style="margin: -24px;">
            <div class="text-lg font-medium">{{isCount ? 'Stock Count -' : receipt ? 'Edit' : 'Add'}} Goods-In Receipt {{receipt ? ('- ' + receipt?.grnRef) : ''}}</div>
            <button
                mat-icon-button
                (click)="close()"
                [tabIndex]="-1">
                <mat-icon
                    class="text-current"
                    [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>
        
        <div class="flex flex-col gap-6 w-full mt-12 max-h-[calc(100vh-230px)] overflow-y-scroll px-1">

            <ng-container *ngIf="!isComplete">
                <div class="border rounded-2xl p-5 grid sm:grid-cols-9 gap-x-6 gap-y-4 w-full bg-[#f8f8f8]">

                    <div class="col-span-9 text-lg flex items-center gap-2">
                        <mat-icon [svgIcon]="'heroicons_outline:document-text'"></mat-icon>
                        <span>Receipt Information</span>
                    </div>
            
                    <ng-container *ngIf="!isCount">
                        <div class="col-span-3">
                            <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                <mat-label>GRN Number</mat-label>
                                <input formControlName="grnRef" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-span-3">
                            <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                <mat-label>PO Number</mat-label>
                                <mat-select formControlName="purchaseOrderId" placeholder="Select Purchase Order..." (selectionChange)="poChanged($event)">
                                    <ng-container *ngFor="let po of purchaseOrders">
                                        <mat-option *ngIf="!po.isDraft && po.status != PurchaseOrderStatus.Complete" [value]="po.purchaseOrderId">{{po.salesOrderRef}}</mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-span-3">
                            <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                <mat-label>Supplier</mat-label>
                                <input matInput [value]="getPo()?.supplier" disabled>
                            </mat-form-field>
                        </div>

                        <div class="col-span-3">
                            <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                <mat-label>Received By</mat-label>
                                <mat-select formControlName="receivedUserId" placeholder="Select Person...">
                                    <ng-container *ngFor="let user of users">
                                        <mat-option [value]="user.id">{{user.firstName}} {{user.lastName}}</mat-option>
                                    </ng-container>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-span-3">
                            <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                <mat-label>Receipt Date</mat-label>
                                <input formControlName="receiptDate" matInput [matDatepicker]="receiptDatePicker">
                                <mat-datepicker-toggle matIconSuffix [for]="receiptDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #receiptDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-span-3">
                            <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                <mat-label>Receipt Time</mat-label>
                                <input formControlName="receiptTime" matInput type="time">
                            </mat-form-field>
                        </div>

                        <div class="col-span-3">
                            <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                <mat-label>Delivery Note Ref</mat-label>
                                <input formControlName="deliveryRef" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-span-3">
                            <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                <mat-label>Carrier</mat-label>
                                <input formControlName="carrier" matInput>
                            </mat-form-field>
                        </div>
                        <div class="col-span-3">
                            <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                <mat-label>Tracking Number</mat-label>
                                <input formControlName="trackingNumber" matInput>
                            </mat-form-field>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="isCount">
                        <div class="col-span-3">
                            <mat-label class="text-md">GRN Number</mat-label>
                            <div>{{receipt?.grnRef}}</div>
                        </div>
                        <div class="col-span-3">
                            <mat-label class="text-md">PO Number</mat-label>
                            <div>{{receipt?.poRef}}</div>
                        </div>
                        <div class="col-span-3">
                            <mat-label class="text-md">Supplier</mat-label>
                            <div>{{receipt?.supplierName}}</div>
                        </div>

                        <div class="col-span-3">
                            <mat-label class="text-md">Received By</mat-label>
                            <div>{{getUserName(receipt?.receivedUserId)}}</div>
                        </div>
                        <div class="col-span-6">
                            <mat-label class="text-md">Receipt Date</mat-label>
                            <div>{{receipt?.receiptDate | date:'dd MMM yyyy, HH:mm'}}</div>
                        </div>

                        <div *ngIf="receipt?.deliveryRef" class="col-span-3">
                            <mat-label class="text-md">Delivery Note Ref</mat-label>
                            <div>{{receipt?.deliveryRef}}</div>
                        </div>
                        <div *ngIf="receipt?.carrier" class="col-span-3">
                            <mat-label class="text-md">Carrier</mat-label>
                            <div>{{receipt?.carrier}}</div>
                        </div>
                        <div *ngIf="receipt?.trackingNumber" class="col-span-3">
                            <mat-label class="text-md">Tracking Number</mat-label>
                            <div>{{receipt?.trackingNumber}}</div>
                        </div>
                    </ng-container>
                </div>

                <!-- Title -->
                <div class="text-lg flex items-center gap-2">
                    <mat-icon *ngIf="!isCount" [svgIcon]="'feather:package'"></mat-icon>
                    <div *ngIf="isCount" class="h-10 w-10 bg-primary-500 rounded-full flex items-center justify-center text-white text-xl mr-1">1</div>
                    <span>{{isCount ? 'Review Items in this Delivery' : 'Receipt Line Items'}}</span>

                    <div *ngIf="!isCount" class="ml-auto border rounded-full overflow-hidden">
                        <button mat-flat-button [class.bg-blue-500]="!isPartial" [class.text-white]="!isPartial" (click)="setPartial(false)">
                            <mat-icon class="icon-size-4" [class.text-white]="!isPartial" svgIcon="feather:check-square"></mat-icon>
                            <span class="ml-2">Full Delivery</span>
                        </button>
                        <button mat-flat-button [class.bg-[#fbbf24]]="isPartial" [class.text-white]="isPartial" (click)="setPartial(true)">
                            <mat-icon class="icon-size-4" [class.text-white]="isPartial" svgIcon="feather:truck"></mat-icon>
                            <span class="ml-2">Partial Delivery</span>
                        </button>
                    </div>
                </div>

                <!-- Review Summary -->
                <ng-container *ngIf="isCount && items?.controls" formArrayName="items">
                    <ng-container *ngFor="let itemControl of items?.controls; let i = index" [formGroupName]="i">
                        <div class="border rounded-2xl px-5 py-3 grid grid-cols-8 gap-x-6 gap-y-4 w-full bg-[#f8f8f8] items-center">
                            <div class="col-span-2">
                                <mat-label class="uppercase tracking-tight">Part No.</mat-label>
                                <div class="text-xl">{{getPoItemPart(itemControl)?.number || 'N/A'}}</div>
                            </div>
                            <div class="col-span-5 truncate elipsis">
                                <div>{{getPoItemPart(itemControl)?.description || getPoItem(itemControl)?.description}}</div>
                            </div>
                            <div class="col-span-1 p-3 text-center rounded-2xl border" [class.bg-blue-100]="!hasPartialDiscrepency(itemControl)" [class.text-blue-700]="!hasPartialDiscrepency(itemControl)" [class.text-[#92400e]]="hasPartialDiscrepency(itemControl)" [class.bg-[#fef3c7]]="hasPartialDiscrepency(itemControl)">
                                <div class="uppercase tracking-tight">Quantity</div>
                                <div class="text-2xl leading-none">{{getExpectedQuantity(itemControl)}}</div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                
                <!-- Title -->
                <div *ngIf="isCount" class="text-lg flex items-center gap-2">
                    <div class="h-10 w-10 bg-primary-500 rounded-full flex items-center justify-center text-white text-xl mr-1">2</div>
                    <span>Count & Allocate Items</span>
                </div>

                <!-- Line Items with Actions -->
                <ng-container *ngIf="items?.controls" formArrayName="items">
                    <ng-container *ngFor="let itemControl of items?.controls; let i = index" [formGroupName]="i">
                        <div class="border rounded-2xl p-5 grid grid-cols-7 gap-x-6 gap-y-4 w-full bg-[#f8f8f8]" [class.grid-cols-8]="!isCount && isPartial">

                            <div class="col-span-7 flex items-center gap-1">
                                <ng-container *ngIf="!isCount">
                                    <mat-icon class="icon-size-5 -mt-1" svgIcon="mat_outline:subdirectory_arrow_right"></mat-icon>
                                    <span>Line {{i+1}}</span>
                                </ng-container>
                                <ng-container *ngIf="isCount">
                                    <div class="w-full grid grid-cols-8 gap-6 border-b pb-4">
                                        <div class="col-span-2">
                                            <mat-label class="uppercase tracking-tight">Part No.</mat-label>
                                            <div class="text-lg">{{getPoItemPart(itemControl)?.number || 'N/A'}}</div>
                                        </div>
                                        <div class="col-span-5">
                                            <mat-label class="uppercase tracking-tight truncate elipsis">Description</mat-label>
                                            <div>{{getPoItemPart(itemControl)?.description || getPoItem(itemControl)?.description}}</div>
                                        </div>
                                        <div class="col-span-1 p-3 text-center rounded-2xl border" [class.bg-blue-100]="!hasPartialDiscrepency(itemControl)" [class.text-blue-700]="!hasPartialDiscrepency(itemControl)" [class.text-[#92400e]]="hasPartialDiscrepency(itemControl)" [class.bg-[#fef3c7]]="hasPartialDiscrepency(itemControl)">
                                            <div class="uppercase tracking-tight">Expected</div>
                                            <div class="text-2xl leading-none">{{getExpectedQuantity(itemControl)}}</div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            
                            <div *ngIf="isCount" class="col-span-3 flex items-end gap-2">
                                <mat-form-field class="flex-auto fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>Location</mat-label>
                                    <mat-select formControlName="locationId" placeholder="Scan or Select Bin Code..." [required]="isCount">
                                        <ng-container *ngFor="let location of locations">
                                            <mat-option [value]="location.partLocationId">{{location.code}}</mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                                <button mat-icon-button (click)="openLocationScanner(itemControl)" [matTooltip]="'Open Scanner'">
                                    <mat-icon svgIcon="mat_outline:qr_code_scanner"></mat-icon>
                                </button>
                            </div>
                            <div *ngIf="isCount" class="col-span-2">
                                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>Received</mat-label>
                                    <input matInput formControlName="received" type="number" [required]="isCount">
                                </mat-form-field>
                            </div>
                            <div *ngIf="isCount" class="col-span-2">
                                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>Damaged</mat-label>
                                    <input matInput formControlName="damaged" type="number" [required]="isCount">
                                </mat-form-field>
                            </div>

                            <div *ngIf="!isCount" class="col-span-2">
                                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>Part Number</mat-label>
                                    <input matInput [value]="getPoItemPart(itemControl)?.number || 'N/A'" disabled>
                                </mat-form-field>
                            </div>
                            <div *ngIf="!isCount" class="col-span-2">
                                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>Description</mat-label>
                                    <input matInput [value]="getPoItemPart(itemControl)?.description || getPoItem(itemControl)?.description" disabled>
                                </mat-form-field>
                            </div>
                            <div *ngIf="!isCount" class="col-span-1">
                                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>Ordered</mat-label>
                                    <input matInput [value]="getPoItem(itemControl)?.quantity" type="number" disabled>
                                </mat-form-field>
                            </div>
                            <div *ngIf="!isCount && isPartial" class="col-span-1">
                                <mat-form-field class="w-full fuse-mat-dense partial-delivery-outline" [subscriptSizing]="'dynamic'">
                                    <mat-label>Delivered</mat-label>
                                    <input matInput formControlName="delivered" type="number" [required]="!isCount && isPartial">
                                </mat-form-field>
                            </div>

                            <!-- <div *ngIf="isCount" class="col-span-3"></div> -->

                            <div *ngIf="!isCount" class="col-span-2">
                                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>Condition</mat-label>
                                    <mat-select formControlName="condition" placeholder="Select Condition..." [required]="!isCount">
                                        <ng-container *ngFor="let option of conditions">
                                            <mat-option [value]="option.value">{{option.name}}</mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <!-- <div *ngIf="isCount" class="col-span-2">
                                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>QA</mat-label>
                                    <mat-select formControlName="qaStatus" placeholder="Select Status...">
                                        <ng-container *ngFor="let option of qaStatuses">
                                            <mat-option [value]="option.value">{{option.name}}</mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>
                            </div> -->

                            <div *ngIf="!isCount" class="col-span-7" [class.col-span-8]="!isCount && isPartial">
                                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>Line Item Notes (damage, packaging issues, etc.)</mat-label>
                                    <input matInput formControlName="lineNotes" placeholder="Any issues or observations...">
                                </mat-form-field>
                            </div>

                            <!-- Partial Discrepencies -->
                            <div *ngIf="!isCount && isPartial && hasPartialDiscrepency(itemControl)" class="col-span-8 bg-[#fef3c7] border border-[#f59e0b] border-2 rounded-2xl p-5 grid grid-cols-2 gap-x-6 gap-y-4">
                                <div class="col-span-2 flex items-center gap-2 text-[#92400e]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="package-open" class="lucide lucide-package-open"><path d="M12 22v-9"></path><path d="M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z"></path><path d="M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13"></path><path d="M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z"></path></svg>
                                    <span style="font-size: 14px; font-weight: 700;">
                                        Partial Delivery: {{getPartialDiscrepency(itemControl)}} unit{{getPartialDiscrepency(itemControl) == 1 ? '' : 's'}} still outstanding
                                    </span>
                                </div>

                                <div>
                                    <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                        <mat-label>Expected Remaining Delivery</mat-label>
                                        <input formControlName="expectedRemainingDeliveryDate" matInput [matDatepicker]="expectedDatePicker" placeholder="Expected date of next delivery...">
                                        <mat-datepicker-toggle matIconSuffix [for]="expectedDatePicker"></mat-datepicker-toggle>
                                        <mat-datepicker #expectedDatePicker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div>
                                    <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                        <mat-label>This Delivery</mat-label>
                                        <mat-select formControlName="partialDeliveryIndex" placeholder="Select Delivery...">
                                            <ng-container *ngFor="let option of partialDeliveryNumbers">
                                                <mat-option [value]="option.value">{{option.name}}</mat-option>
                                            </ng-container>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-span-2">
                                    <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                        <mat-label>Supplier Notes / Reason</mat-label>
                                        <input matInput formControlName="partialReason" placeholder="e.g. Supplier advised remaining 50 units will ship next week...">
                                    </mat-form-field>
                                </div>
                                
                            </div>

                            <!-- Count Discrepancy -->
                            <div *ngIf="isCount && hasCountDiscrepency(itemControl) && itemControl.controls['received'].value != 0" class="col-span-7 bg-[#fef3c7] border border-[#f59e0b] border-2 rounded-2xl p-5">
                                <div class="flex items-center gap-2 text-[#92400e]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="alert-triangle" class="lucide lucide-alert-triangle"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path><path d="M12 9v4"></path><path d="M12 17h.01"></path></svg>
                                    <div>
                                        <strong style="font-size: 14px;">Count Discrepancy Detected</strong>
                                        <p style="margin: 4px 0 0 0; font-size: 13px;">Counted quantity doesn't match expected. This will be flagged for review.</p>
                                    </div>
                                </div>
                            </div>

                            <!-- Damage -->
                            <div *ngIf="isCount && hasDamage(itemControl)" class="col-span-7 bg-[#fef2f2] border border-[#ef4444] border-2 rounded-2xl p-5 flex flex-col gap-4">
                                <div class="flex items-center gap-2 text-[#991b1b]">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="package-x" class="lucide lucide-package-x"><path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"></path><path d="m7.5 4.27 9 5.15"></path><polyline points="3.29 7 12 12 20.71 7"></polyline><line x1="12" x2="12" y1="22" y2="12"></line><path d="m17 13 5 5m-5 0 5-5"></path></svg>
                                    <strong style="font-size: 14px;">Damaged Goods Detected - Additional Information Required</strong>
                                </div>

                                
                                <div class="w-full flex items-end gap-2">
                                    <mat-form-field class="flex-auto fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                        <mat-label>Quarantine Location</mat-label>
                                        <mat-select formControlName="quarantineLocationId" placeholder="Scan or Select Quarantine Bin..." [required]="hasDamage(itemControl)">
                                            <ng-container *ngFor="let location of locations">
                                                <mat-option [value]="location.partLocationId">{{location.code}}</mat-option>
                                            </ng-container>
                                        </mat-select>
                                    </mat-form-field>
                                    <button mat-icon-button (click)="openLocationScanner(itemControl, true)" [matTooltip]="'Open Scanner'">
                                        <mat-icon svgIcon="mat_outline:qr_code_scanner"></mat-icon>
                                    </button>
                                </div>

                                <div class="w-full flex flex-col gap-2">
                                    <mat-label>Photo Evidence*</mat-label>
                                    <div class="w-full flex gap-3 items-center">
                                        <button mat-flat-button color="primary" (click)="openDamageFileUpload(itemControl)">
                                            <mat-icon [svgIcon]="'mat_outline:photo_camera'"></mat-icon>
                                            <span class="ml-1">Upload Photos</span>
                                        </button>
                                        <span *ngIf="!hasImages(itemControl)">No photos added</span>
                                    </div>

                                    <!-- Damage Images -->
                                    <div class="w-full flex flex-row flex-wrap gap-2">
                                        <ng-container *ngFor="let url of damageUrls; let i = index">
                                            <div *ngIf="damageFileInfos[i].goodsInLineItemId == getLineItemId(itemControl)" class="relative h-24 min-w-24 max-w-32 flex items-center border rounded-xl overflow-hidden bg-white">
                                                <img [src]="url" />
                                                <mat-icon
                                                    class="bg-white text-[var(--dlm-red)] rounded-full icon-size-6 absolute cursor-pointer top-[5px] right-[5px]"
                                                    [svgIcon]="'heroicons_solid:x-circle'"
                                                    matTooltip="Delete Image"
                                                    (click)="deleteDamageFile(i, $event)">
                                                </mat-icon>
                                                <mat-icon
                                                    class="bg-white text-[var(--dlm-green)] rounded-full icon-size-6 absolute cursor-pointer bottom-[5px] right-[5px]"
                                                    [svgIcon]="'mat_solid:download_for_offline'"
                                                    matTooltip="Download Image"
                                                    (click)="downloadDamageImage(i)">
                                                </mat-icon>
                                            </div>
                                        </ng-container>
                                    </div>

                                </div>

                                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>Disposition</mat-label>
                                    <mat-select formControlName="damageDisposition" placeholder="Select Action..." [required]="hasDamage(itemControl)">
                                        <ng-container *ngFor="let option of damageDispositions">
                                            <mat-option [value]="option.value">{{option.name}}</mat-option>
                                        </ng-container>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                                    <mat-label>Damage Description</mat-label>
                                    <textarea
                                        matInput
                                        formControlName="damageDescription"
                                        placeholder="Describe the damage (e.g. dented corner, broken packaging, scratched surface...)"
                                        [required]="hasDamage(itemControl)"
                                        [rows]="2"
                                        cdkTextareaAutosize
                                        [cdkAutosizeMinRows]="2">
                                    </textarea>
                                </mat-form-field>

                                <div class="bg-[#fef3c7] border border-[#fbbf24] rounded-2xl p-4">
                                    <div class="flex items-center gap-2 text-[#92400e]">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="info" style="margin-top: 2px;" class="lucide lucide-info"><circle cx="12" cy="12" r="10"></circle><path d="M12 16v-4"></path><path d="M12 8h.01"></path></svg>
                                        <p style="margin: 0; font-size: 12px;">This will automatically create a supplier claim and notify the purchasing team for review.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </ng-container>
                </ng-container>


                <!-- Attach Images -->
                <div *ngIf="!isCount" class="border rounded-2xl flex flex-col gap-x-6 gap-y-4 p-5 w-full bg-[#f8f8f8]">
                    <div class="text-lg flex items-center gap-2">
                        <mat-icon [svgIcon]="'mat_outline:photo_camera'"></mat-icon>
                        <span>Attach Photos</span>
                    </div>

                    <div>
                        <button mat-flat-button color="primary" (click)="openFileUpload()">
                            Upload Photos
                            <mat-icon [svgIcon]="'mat_outline:file_upload'"></mat-icon>
                        </button>
                    </div>

                    <!-- Images -->
                    <div *ngIf="urls?.length > 0" class="w-full flex flex-row flex-wrap gap-2">
                        <ng-container *ngFor="let url of urls; let i = index">
                            <div class="relative h-24 min-w-24 max-w-32 flex items-center border rounded-xl overflow-hidden bg-white">
                                <img [src]="url" />
                                <mat-icon
                                    class="bg-white text-[var(--dlm-red)] rounded-full icon-size-6 absolute cursor-pointer top-[5px] right-[5px]"
                                    [svgIcon]="'heroicons_solid:x-circle'"
                                    matTooltip="Delete Image"
                                    (click)="deleteFile(i, $event)">
                                </mat-icon>
                                <mat-icon
                                    class="bg-white text-[var(--dlm-green)] rounded-full icon-size-6 absolute cursor-pointer bottom-[5px] right-[5px]"
                                    [svgIcon]="'mat_solid:download_for_offline'"
                                    matTooltip="Download Image"
                                    (click)="downloadImage(i)">
                                </mat-icon>
                            </div>
                        </ng-container>
                    </div>

                    <div>Upload photos of delivery, packing slip, or any damaged goods</div>
                </div>

                <!-- Receipt Notes -->
                <!-- <div class="border rounded-2xl p-5 w-full bg-[#f8f8f8]"> -->
                <mat-form-field *ngIf="!isCount" class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Receipt Notes</mat-label>
                    <textarea
                        formControlName="notes"
                        placeholder="Any additional notes about this delivery..."
                        matInput
                        [rows]="2"
                        cdkTextareaAutosize
                        [cdkAutosizeMinRows]="2">
                    </textarea>
                </mat-form-field>
                <!-- </div> -->
            </ng-container>
            <ng-container *ngIf="isComplete">
                
                <!-- Title -->
                <div *ngIf="!isView" class="flex flex-col items-center gap-2">
                    <div class="h-20 w-20 bg-green-500 rounded-full flex items-center justify-center">
                        <mat-icon class="icon-size-10 text-white" svgIcon="feather:check-circle"></mat-icon>
                    </div>
                    <div class="text-2xl">Count Completed Successfully!</div>
                    <div>All items have been counted and allocated to warehouse locations.</div>
                </div>

                <!-- Stats -->
                <div *ngIf="!isView" class="grid grid-cols-2 gap-4">
                    <div class="bg-green-100 border border-green-500 rounded-2xl text-green-600 p-5 flex flex-col items-center gap-2">
                        <span class="text-3xl">{{getTotalItemCount()}}</span>
                        <span>Items Scanned</span>
                    </div>

                    <div class="bg-[#fef3c7] border border-[#fbbf24] rounded-2xl p-5 text-[#92400e] flex flex-col items-center gap-2">
                        <span class="text-3xl">{{receipt?.itemCount}}</span>
                        <span>Line Items</span>
                    </div>

                    <div class="bg-[#fef2f2] border border-[#ef4444] border-2 rounded-2xl text-[#991b1b] p-5 flex flex-col items-center gap-2">
                        <span class="text-3xl">{{getTotalDamageCount()}}</span>
                        <span>Damaged/Faulty</span>
                    </div>
                    <div class="bg-[#fef2f2] border border-[#ef4444] border-2 rounded-2xl text-[#991b1b] p-5 flex flex-col items-center gap-2">
                        <span class="text-3xl">{{getTotalDiscrepencyCount()}}</span>
                        <span>Missing/Short</span>
                    </div>
                </div>

                <div *ngIf="isView" class="grid grid-cols-3 gap-4 p-5 rounded-2xl border">
                    <div>
                        <mat-label class="text-md">GRN Number</mat-label>
                        <div class="text-lg">{{receipt?.grnRef}}</div>
                    </div>
                    <div>
                        <mat-label class="text-md">PO Number</mat-label>
                        <div class="text-lg">{{receipt?.poRef}}</div>
                    </div>
                    <div>
                        <mat-label class="text-md">Supplier</mat-label>
                        <div class="text-lg">{{receipt?.supplierName}}</div>
                    </div>
                    <div>
                        <mat-label class="text-md">Receipt Date</mat-label>
                        <div class="text-lg">{{receipt?.receiptDate | date:'dd/MM/yyyy HH:mm'}}</div>
                    </div>
                    <div>
                        <mat-label class="text-md">Received By</mat-label>
                        <div class="text-lg">{{getUserName(receipt?.receivedUserId)}}</div>
                    </div>
                    <div class="flex flex-col">
                        <mat-label class="text-md">Overall Status</mat-label>
                        <div class="text-center text-md" [style]="getStatusStyle(receipt.status)">{{ getStatusName(receipt.status) }}</div>
                    </div>
                </div>

                <!-- Title -->
                <div class="text-lg flex items-center gap-2 -mb-2 mt-2">
                    <mat-icon [svgIcon]="'mat_outline:checklist'"></mat-icon>
                    <span>Item Details</span>
                </div>

                <!-- Item List -->
                <div class="border rounded-2xl px-5 pt-5 grid gap-x-6 gap-y-0 w-full bg-[#f8f8f8] divide-y">
                    <div class="grid grid-cols-12 gap-x-6 gap-y-4 pb-3">
                        <div class="col-span-1">Line</div>
                        <div class="col-span-2">Part Number</div>
                        <div class="col-span-3">Description</div>
                        <div class="">Expected</div>
                        <div class="">Counted</div>
                        <div class="">Damaged</div>
                        <div class="">Missing</div>
                        <div class="col-span-2">Location</div>
                    </div>

                    <ng-container *ngIf="items?.controls" formArrayName="items">
                        <ng-container *ngFor="let itemControl of items?.controls; let i = index" [formGroupName]="i">
                            <div class="grid grid-cols-12 gap-x-6 gap-y-4 py-3 items-center bg-white px-5 -mx-5 rounded-b-2xl">
                                <div class="col-span-1">{{i+1}}</div>
                                <div class="col-span-2">{{getPoItemPart(itemControl)?.number || 'N/A'}}</div>
                                <div class="col-span-3">{{getPoItemPart(itemControl)?.description || getPoItem(itemControl)?.description}}</div>

                                <div class="col-span-1">
                                    <div class="rounded-lg p-2 flex items-center justify-center" [class.bg-[#fef3c7]]="hasPartialDiscrepency(itemControl)" [class.text-[#92400e]]="hasPartialDiscrepency(itemControl)">
                                        {{getExpectedQuantity(itemControl)}}
                                    </div>
                                </div>
                                <div class="col-span-1">
                                    <div class="rounded-lg p-2 flex items-center justify-center" [class.bg-green-100]="!hasCountDiscrepency(itemControl)"  [class.text-green-600]="!hasCountDiscrepency(itemControl)" [class.text-[#92400e]]="hasCountDiscrepency(itemControl)" [class.bg-[#fef3c7]]="hasCountDiscrepency(itemControl)">
                                        {{itemControl.controls['received'].value}}
                                    </div>
                                </div>
                                <div class="col-span-1">
                                    <div class="rounded-lg p-2 flex items-center justify-center" [class.bg-blue-100]="!hasDamage(itemControl)" [class.text-blue-700]="!hasDamage(itemControl)" [class.text-[#991b1b]]="hasDamage(itemControl)" [class.bg-[#fef2f2]]="hasDamage(itemControl)">
                                        {{itemControl.controls['damaged'].value}}
                                    </div>
                                </div>
                                <div class="col-span-1">
                                    <div class="rounded-lg p-2 flex items-center justify-center" [class.bg-blue-100]="!hasCountDiscrepency(itemControl)" [class.text-blue-700]="!hasCountDiscrepency(itemControl)" [class.text-[#991b1b]]="hasCountDiscrepency(itemControl)" [class.bg-[#fef2f2]]="hasCountDiscrepency(itemControl)">
                                        {{getCountDiscrepency(itemControl)}}
                                    </div>
                                </div>
                                <div class="col-span-2">
                                    <div class="rounded-lg py-2 px-4 flex items-center bg-blue-100 text-blue-700 gap-2">
                                        <mat-icon class="icon-size-5 text-blue-700" [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
                                        <span>{{getLocationCode(itemControl)}}</span>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>

                <!-- Damaged Goods -->
                <div *ngIf="getTotalDamageCount() > 0" class="bg-[#fef2f2] border border-[#ef4444] border-2 rounded-2xl p-5 flex flex-col gap-4">
                    <div class="flex items-center gap-2 text-[#991b1b]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="package-x" class="lucide lucide-package-x"><path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"></path><path d="m7.5 4.27 9 5.15"></path><polyline points="3.29 7 12 12 20.71 7"></polyline><line x1="12" x2="12" y1="22" y2="12"></line><path d="m17 13 5 5m-5 0 5-5"></path></svg>
                        <div class="flex flex-col">
                            <strong style="font-size: 14px;">Damaged Goods Detected - Supplier Claim Required</strong>
                            <span>{{getTotalDamageCount()}} item{{getTotalDamageCount() == 1 ? '' : 's'}} with damage {{getTotalDamageCount() == 1 ? 'has' : 'have'}} been quarantined. Purchasing team has been notified.</span>
                        </div>
                    </div>

                    <!-- Individual Item Damage Cards -->
                    <ng-container *ngIf="items?.controls" formArrayName="items">
                        <ng-container *ngFor="let itemControl of items?.controls; let i = index" [formGroupName]="i">
                            <div *ngIf="hasDamage(itemControl)" class="bg-white border border-[#ef4444] rounded-2xl p-5 flex flex-col gap-4">
                                
                                <div class="grid grid-cols-5 gap-4">
                                    <div class="flex flex-col gap-2">
                                        <div class="uppercase text-[#991b1b] tracking-tight">Part Number</div>
                                        <span class="text-xl">{{getPoItemPart(itemControl)?.number || 'N/A'}}</span>
                                    </div>
                                    <div class="col-span-3 flex flex-col gap-2">
                                        <div class="uppercase text-[#991b1b] tracking-tight">Description</div>
                                        <span>{{getPoItemPart(itemControl)?.description || getPoItem(itemControl)?.description}}</span>
                                    </div>
                                    <div class="flex flex-col gap-2">
                                        <div class="uppercase text-[#991b1b] tracking-tight text-right">Qty Damaged</div>
                                        <span class="text-xl text-red-500 text-right">{{itemControl.controls['damaged'].value}}</span>
                                    </div>
                                </div>

                                <div class="grid grid-cols-3 bg-[#fef2f2] p-4 rounded-lg gap-x-6">
                                    <div class="flex flex-col gap-1">
                                        <div>Quarantine Location</div>
                                        <div class="bg-white py-2 px-4 border rounded-lg">{{getLocationCode(itemControl, true)}}</div>
                                    </div>
                                    <div class="flex flex-col gap-1">
                                        <div>Disposition</div>
                                        <div class="bg-white py-2 px-4 border rounded-lg">{{getDamageDispositionName(itemControl.controls['damageDisposition'].value)}}</div>
                                    </div>
                                    <div class="flex flex-col gap-1">
                                        <div>Photo Evidence</div>
                                        <div class="bg-white py-2 px-4 border rounded-lg text-green-600">{{countImages(itemControl)}} Photos</div>
                                    </div>
                                </div>

                                <div class="flex flex-col gap-1">
                                    <div>Damage Description:</div>
                                    <div>{{itemControl.controls['damageDescription'].value}}</div>
                                </div>

                            </div>
                        </ng-container>
                    </ng-container>

                    <!-- Moved to quarantine info box -->
                    <div style="background: #fef3c7; border: 1px solid #fbbf24; padding: 16px; border-radius: 8px;">
                        <div style="display: flex; align-items: start; gap: 12px; color: #92400e;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="package-x" style="flex-shrink: 0; margin-top: 2px;" class="lucide lucide-package-x"><path d="M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14"></path><path d="m7.5 4.27 9 5.15"></path><polyline points="3.29 7 12 12 20.71 7"></polyline><line x1="12" x2="12" y1="22" y2="12"></line><path d="m17 13 5 5m-5 0 5-5"></path></svg>
                            <div style="flex: 1;">
                                <strong style="display: block; margin-bottom: 6px; font-size: 14px;">Items Moved to Quarantine</strong>
                                <p style="margin: 0 0 12px 0; font-size: 13px;">All damaged items have been automatically moved to the quarantine area for review. You can view details, generate RMA requests, and track the return process from there.</p>
                                
                                <button mat-flat-button color="primary" type="button" (click)="close()" [routerLink]="['/part-register/quarantine']">
                                    <mat-icon svgIcon="heroicons_outline:arrow-small-right"></mat-icon>
                                    <span class="ml-1">View Quarantine Area</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Count Discrepencies -->
                <div *ngIf="getTotalDiscrepencyCount() > 0" class="bg-[#fef3c7] border border-[#f59e0b] border-2 rounded-2xl p-5">
                    <div class="flex items-center gap-2 text-[#92400e]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="alert-triangle" class="lucide lucide-alert-triangle"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3"></path><path d="M12 9v4"></path><path d="M12 17h.01"></path></svg>
                        <div>
                            <strong style="font-size: 14px;">Count Discrepancies Detected</strong>
                            <p style="margin: 4px 0 0 0; font-size: 13px;">{{getTotalDiscrepencyCount()}} item{{getTotalDiscrepencyCount() == 1 ? '' : 's'}} with discrepancies {{getTotalDiscrepencyCount() == 1 ? 'has' : 'have'}} been flagged for review.</p>
                        </div>
                    </div>
                </div>


            </ng-container>
        </div>

        <!-- Divider -->
        <div class="my-6 border-t"></div>

        <!-- Actions -->
        <div class="flex flex-row items-between w-full gap-4">
            <div class="flex items-center justify-end ml-auto gap-4">
                <button
                    (click)="close()"
                    mat-stroked-button
                    type="button">
                    {{isComplete ? 'Close' : 'Cancel'}}
                </button>
                
                <button
                    *ngIf="isComplete && anyCountDiscrepencies()"
                    (click)="emailSupplierShortDelivery()"
                    mat-flat-button
                    type="button"
                    [color]="'primary'">
                    <mat-icon class="icon-size-4 mr-1" svgIcon="heroicons_outline:paper-airplane"></mat-icon>
                    <span class="ml-1">Email Supplier about Missing Parts</span>
                </button>

                <button
                    *ngIf="!isCount && !isComplete"
                    (click)="save()"
                    mat-stroked-button
                    type="button"
                    [disabled]="!form?.valid">
                    <mat-icon class="icon-size-4" svgIcon="feather:package"></mat-icon>
                    <span class="ml-1">Park for Later Count</span>
                </button>

                <button
                    *ngIf="!isComplete"
                    (click)="save(true)"
                    mat-flat-button
                    type="button"
                    [color]="'primary'"
                    [disabled]="!form?.valid || (isCount && anyMissingDamageImages())">
                    <mat-icon class="icon-size-4 mr-1" svgIcon="feather:check-circle"></mat-icon>
                    <span class="ml-1">{{isCount ? 'Save Count' : 'Count Now'}}</span>
                </button>
            </div>
        </div>
    </form>

    <div id="print-preview3" class="w-full" style="display: none; margin-top: 2000px;">
        <purchase-order-preview
            #purchaseOrderPreview3
            [purchaseOrder]="print_po"
            [hireItems]="[]"
            [partItems]="print_partItems"
            [productItems]="[]"
            [contact]="print_contact"
            [printSectionId]="'print-section3'">
        </purchase-order-preview>
    </div>

</div>
